var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.438.375h-1.3c-.315 0-.57.26-.562.576l.11 4.62A11.61 11.61 0 0 0 11.963.375C5.57.395.365 5.625.375 12.019.385 18.43 5.585 23.625 12 23.625c2.996 0 5.728-1.134 7.79-2.996a.564.564 0 0 0 .022-.817l-.925-.925a.564.564 0 0 0-.774-.026A9.15 9.15 0 0 1 12 21.187 9.183 9.183 0 0 1 2.813 12 9.183 9.183 0 0 1 12 2.813a9.18 9.18 0 0 1 8.375 5.404l-5.924-.14a.563.563 0 0 0-.576.562v1.299c0 .31.252.562.563.562h9c.31 0 .562-.252.562-.562v-9a.56.56 0 0 0-.562-.563"
  }))));
};
export default SvgRedo;